import padStart from 'lodash/padStart';
import { PreparedServerCard, ServerCard } from '../types';
import { maskDot } from '../constants';

const formatCardNumber = (cardNumber: string) => {
  const match = cardNumber.match(/.{1,4}|^$/g) || [];

  return match.join(' ').replace(/x/g, maskDot);
};

const prepareCard = (card: ServerCard): PreparedServerCard => {
  const { cardMask, cardId, cardHolder, isOTTCard, expYear, expMonth } = card;

  const formattedYear = expYear.length === 4 ? expYear.slice(2, 4) : expYear;
  const formattedMonth = padStart(expMonth, 2, '0');

  return {
    id: cardId,
    cardNumber: formatCardNumber(cardMask),
    cardHolder,
    year: formattedYear,
    month: formattedMonth,
    isOTTCard,
  };
};

export const prepareCards = (cards: ServerCard[]): PreparedServerCard[] => {
  return cards.reduce((acc, card) => {
    if (card.status === 'IsActive') {
      acc.push(prepareCard(card));
    }

    return acc;
  }, [] as PreparedServerCard[]);
};
